export const Environment = {
  production: process.env.PRODUCTION,
  appName: process.env.APP_NAME,
};
